import React from "react";
import { DamAdmin } from "../DamAdmin/DamAdmin";
import { DamsContainer, TableHeader } from "./DamsAdminStyles";

export const DamsAdmin = (props) => {
  const {
    dams,
    updateSelectedVolantes,
    dateRucHook,
    onChangeVolantesForInvoice,
    loadDateWithdrawal,
    dni,
    refreshBilling,
  } = props;

  return (
    <DamsContainer>
      <TableHeader>
        <div className="main-info-header">DAM/CONSIGNATARIO</div>
        <div>TIPO DE RETIRO</div>
        <div>ESTADO DAM</div>
        <div>FECHA LEVANTE</div>
        <div>VOLANTES FACTURADOS</div>
      </TableHeader>
      <div>
        {dams.map((dam) => (
          <DamAdmin
            dni={dni}
            loadDateWithdrawal={loadDateWithdrawal}
            key={dam.id}
            dateRucHook={dateRucHook}
            updateSelectedVolantes={updateSelectedVolantes}
            onChangeVolantesForInvoice={onChangeVolantesForInvoice}
            dam={dam}
            refreshBilling={refreshBilling}
          />
        ))}
      </div>
    </DamsContainer>
  );
};
